/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * CESmon API
 * OpenAPI spec version: 0.0.1
 */
import { HttpClient, HttpHeaders, HttpResponse as AngularHttpResponse } from '@angular/common/http';
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CampaignCompletion,
  CampaignCompletionBatchRequest,
  CampaignCompletionBatchResponse,
  GetCampaignCompletionListResourceParams,
} from '../model';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?: HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: { includeHeaders?: string[] } | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
): Record<string, AngularHttpParamValueWithNullable> {
  const filteredParams: Record<string, AngularHttpParamValueWithNullable> = {};
  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      const filtered = value.filter(
        item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (preserveRequiredNullables && value === null && requiredNullableKeys.has(key)) {
      filteredParams[key] = null;
    } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}

@Injectable({ providedIn: 'root' })
export class CampaignCompletionsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Completion status by campaign or asset (exactly one required)
   */
  getCampaignCompletionListResource<TData = CampaignCompletion[]>(
    params?: GetCampaignCompletionListResourceParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getCampaignCompletionListResource<TData = CampaignCompletion[]>(
    params?: GetCampaignCompletionListResourceParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getCampaignCompletionListResource<TData = CampaignCompletion[]>(
    params?: GetCampaignCompletionListResourceParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getCampaignCompletionListResource<TData = CampaignCompletion[]>(
    params?: GetCampaignCompletionListResourceParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({ ...params, ...options?.params }, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(`/campaign-completions`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/campaign-completions`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`/campaign-completions`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * @summary Completion status + campaign infos for multiple campaigns
   */
  postCampaignCompletionBatchResource<TData = CampaignCompletionBatchResponse>(
    campaignCompletionBatchRequest: CampaignCompletionBatchRequest,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  postCampaignCompletionBatchResource<TData = CampaignCompletionBatchResponse>(
    campaignCompletionBatchRequest: CampaignCompletionBatchRequest,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  postCampaignCompletionBatchResource<TData = CampaignCompletionBatchResponse>(
    campaignCompletionBatchRequest: CampaignCompletionBatchRequest,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  postCampaignCompletionBatchResource<TData = CampaignCompletionBatchResponse>(
    campaignCompletionBatchRequest: CampaignCompletionBatchRequest,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`/campaign-completions/batch`, campaignCompletionBatchRequest, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`/campaign-completions/batch`, campaignCompletionBatchRequest, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`/campaign-completions/batch`, campaignCompletionBatchRequest, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
}
